export const AVATAR_DEFAULT_WIDTH = '30px';
export const AVATAR_DEFAULT_HEIGHT = AVATAR_DEFAULT_WIDTH;
export const AVATAR_DEFAULT_IMAGE_ICON = 'user';
export const AVATAR_DEFAULT_ICON_COLOUR = 'white';
export const AVATAR_DEFAULT_ICON_BACKGROUND = 'russian';